import React from "react";
import Tooltip from "./Tooltip";

function SelectInput({ customInput, data }) {
  const { label, name, value, action, tooltipBool, tooltipText, disabled, error, required } =
    customInput;

  return (
    <>
      <label htmlFor={name}>
        {label}
        {required && <span className="field-required">*</span>}
        {tooltipBool === true && <Tooltip text={tooltipText}></Tooltip>}
      </label>
      <select
        name={name}
        value={value}
        onChange={action}
        disabled={disabled}
        className={error ? "input-error" : ""}
      >
        <option key="placeholder" disabled defaultChecked value="">
          Select an option
        </option>

        {data.map((option) => {
          if (option.value === "" && option.text === "") {
            return <option key="placeholder" hidden disabled value=""></option>;
          } else {
            return (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled ?? false}
              >
                {option.text}
              </option>
            );
          }
        })}
      </select>
      {error && <span className="field-error-msg">{error}</span>}
    </>
  );
}

export default SelectInput;
